import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PharmacistDashboard from '../components/Pharmacist/PharmacistDashboard';
import EligibilityCheck from '../components/Pharmacist/EligibilityCheck';
import DispenseForm from '../components/Pharmacist/DispenseForm';
import ReimbursementRequests from '../components/Pharmacist/ReimbursementRequests';

const PharmacistPage = () => {
  return (
    <div className="page-content">
      <Routes>
        <Route path='accueil' element={<PharmacistDashboard />} />
        <Route path="verify" element={<EligibilityCheck />} />
        <Route path="dispense" element={<DispenseForm />} />
        <Route path="requests" element={<ReimbursementRequests />} />
      </Routes>
    </div>
  );
};

export default PharmacistPage;